var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4022_5991)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3346 23.5454C14.9204 24.2628 15.1644 25.1735 15.6525 26.9949L17.8093 35.0443C18.2973 36.8656 18.5413 37.7763 19.2588 38.1905C19.9762 38.6047 20.8869 38.3607 22.7083 37.8727L37.5191 33.9041C39.3405 33.4161 40.2512 33.1721 40.6654 32.4546C41.0796 31.7372 40.8356 30.8265 40.3476 29.0051L38.1907 20.9558C37.7027 19.1344 37.4587 18.2237 36.7412 17.8095C36.0238 17.3953 35.1131 17.6393 33.2918 18.1273L18.4809 22.0959C16.6595 22.5839 15.7488 22.8279 15.3346 23.5454ZM18.645 24.6401C18.1115 24.7831 17.7949 25.3314 17.9379 25.8649C18.0808 26.3983 18.6291 26.7149 19.1626 26.572L21.4164 25.9681C21.9499 25.8251 22.2665 25.2768 22.1235 24.7433C21.9806 24.2098 21.4323 23.8933 20.8988 24.0362L18.645 24.6401ZM33.8765 31.2567C33.7335 30.7232 34.0501 30.1749 34.5836 30.032L36.8374 29.428C37.3709 29.2851 37.9192 29.6017 38.0622 30.1352C38.2051 30.6686 37.8885 31.217 37.355 31.3599L35.1012 31.9638C34.5678 32.1067 34.0194 31.7902 33.8765 31.2567ZM29.4489 27.6118C29.6633 28.412 29.1884 29.2345 28.3882 29.4489C27.588 29.6633 26.7655 29.1884 26.5511 28.3882C26.3367 27.588 26.8116 26.7655 27.6118 26.5511C28.412 26.3367 29.2345 26.8116 29.4489 27.6118ZM31.3808 27.0941C31.881 28.9613 30.773 30.8804 28.9059 31.3807C27.0387 31.881 25.1196 30.773 24.6193 28.9059C24.119 27.0387 25.227 25.1196 27.0941 24.6193C28.9613 24.119 30.8805 25.227 31.3808 27.0941Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4022_5991",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.780392 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4022_5991"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCircle);
export default __webpack_public_path__ + "static/media/money_circle.357ebc34e92864631d03803c10089807.svg";
export { ForwardRef as ReactComponent };